/* eslint-disable react/jsx-no-bind */
// This is the only realistic key for slots and is recommended in the docs
/* eslint-disable react/no-array-index-key */
// Spreading is recommended by otp input and TS can point out any later potential issues
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { OTPInput } from 'input-otp';
import { Slot } from './Slot';
import styles from './styles.module.scss';

/**
 * @typedef {object} OtpInputProps
 * @property {string} [dataTestId] - data-testid attribute for testing
 * @property {() => void} [onBlur] - onBlur event handler
 * @property {() => void} [onFoucs] - onFocus event handler
 * @property {boolean | "false" | "true" | "grammar" | "spelling" | undefined} [aria-invalid] - set to "true" if field is invalid
 * @property {string} name - name attribute for the input field
 * @property {(ev: ChangeEvent) => void} onChange - onChange event handler
 * @property {string} value - value of the input field
 * @property {string} [id] - id attribute for the input field
 * @property {string} [placeholder] - placeholder text for the input field
 */

/**
 * @typedef {{
 *   target: {
 *     name: string;
 *     value: string;
 *   }
 * }} ChangeEvent
 */

/**
 * A component for entering OTP (One Time Password) codes.
 * @param {OtpInputProps} props
 */
export function OtpInput({ onChange, name, ...inputProps }) {
  /**
   * @param {string} value
   */
  function handleChange(value) {
    onChange({ target: { value, name } });
  }

  return (
    <div>
      <OTPInput
        containerClassName={String(styles.group)}
        render={({ slots }) => (
          <>
            <div className={styles.flex}>
              {slots.map((slot, idx) => (
                <Slot key={idx} {...slot} />
              ))}
            </div>
          </>
        )}
        maxLength={6}
        onChange={handleChange}
        name={name}
        {...inputProps}
      />
    </div>
  );
}
